import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChatContainer from "../../../../../components/chat/chatContainer/ChatContainer";
import SendIcon from "../../../../../components/icons/SendIcon";
import TextArea from "../../../../../components/inputs/textArea/TextArea";
import TextWrapper from "../../../../../components/textWrapper/TextWrapper";
import {
  markAsReadByAdmin,
  sendSupportMessage,
  toggleChatAccess,
} from "../../../../../features/supportChat/supportChatSlice";
import styles from "./chatWindow.module.css";

const ChatWindow = () => {
  const dispatch = useDispatch();
  const [chatMessage, setChatMessage] = useState("");
  const { activeChatId, activeUserId } = useSelector(
    (state) => state.supportChat
  );

  const justSentMessage = useRef(false);

  const handleChatAccessToggle = () => {
    dispatch(
      toggleChatAccess({
        userId: activeUserId?._id,
        access: !activeUserId?.chatAccess,
      })
    );
  };

  useEffect(() => {
    dispatch(markAsReadByAdmin(activeChatId));
  }, [activeChatId, dispatch]);

  const handleSendMessage = () => {
    if (!chatMessage.trim()) return;

    justSentMessage.current = true;

    dispatch(
      sendSupportMessage({ chatId: activeChatId, message: chatMessage })
    );

    setChatMessage("");
  };

  return (
    <div className={styles.contnainer}>
      <div className={styles.chatHeader}>
        <div
          className={
            activeUserId?.chatAccess
              ? `${styles.togglerWrapper} ${styles.active}`
              : styles.togglerWrapper
          }
          onClick={handleChatAccessToggle}
        >
          <div
            className={
              activeUserId?.chatAccess
                ? `${styles.toggle} ${styles.active}`
                : styles.toggle
            }
          ></div>
        </div>
        <TextWrapper textStyle={"textMid"}>{activeUserId?.name}</TextWrapper>
      </div>
      <div className={styles.chatWrapper}>
        <ChatContainer justSentMessage={justSentMessage} />
      </div>
      <div className={styles.chatInputWrapper}>
        <div
          className={styles.sendBtnWrapper}
          onClick={() => handleSendMessage()}
        >
          <SendIcon className={styles.sendIcon} />
        </div>

        <TextArea
          value={chatMessage}
          onChange={(e) => setChatMessage(e.target.value)}
        />
      </div>
    </div>
  );
};

export default ChatWindow;
